// src/components/QASection/QASection.tsx
import { useState } from "react";
import styles from "./style.module.scss"; // Renamed SCSS file accordingly

interface QAItem {
  id: number;
  question: string;
  answer: string;
  hasVideo: boolean;
  videoUrl?: string;
}

const QASection: React.FC = () => {
  const [expandedItem, setExpandedItem] = useState<number | null>(null);

  const qaItems: QAItem[] = [
    {
      id: 1,
      question: "How do I get started with React?",
      answer:
        "React is a JavaScript library for building user interfaces. To get started, you need basic knowledge of HTML, CSS, and JavaScript. The official React documentation provides excellent tutorials for beginners.",
      hasVideo: true,
      videoUrl: "https://example.com/videos/react-getting-started.mp4",
    },
    {
      id: 2,
      question: "What are React hooks?",
      answer:
        "Hooks are functions that let you 'hook into' React state and lifecycle features from function components. They were introduced in React 16.8. The most commonly used hooks are useState and useEffect.",
      hasVideo: true,
      videoUrl: "https://example.com/videos/react-hooks-explained.mp4",
    },
    {
      id: 3,
      question: "How do I handle forms in React?",
      answer:
        "In React, form elements work a bit differently from regular DOM elements because form elements naturally keep some internal state. There are two main approaches: controlled components and uncontrolled components.",
      hasVideo: false,
    },
    {
      id: 4,
      question: "What is the virtual DOM?",
      answer:
        "The Virtual DOM is a lightweight JavaScript representation of the real DOM. React uses it to improve performance by minimizing direct manipulations to the actual DOM. When state changes, React updates the Virtual DOM, diffs it, and syncs changes to the real DOM.",
      hasVideo: true,
      videoUrl: "https://example.com/videos/virtual-dom-explained.mp4",
    },
  ];

  const toggleItem = (id: number) => {
    setExpandedItem(expandedItem === id ? null : id);
  };

  return (
    <div className={styles.qaSection}>
      <div className={styles.list}>
        {qaItems.map((item) => (
          <div key={item.id} className={styles.qaItem}>
            <button
              className={styles.question}
              onClick={() => toggleItem(item.id)}
              aria-expanded={expandedItem === item.id}
            >
              <span>{item.question}</span>
              <span className={styles.toggle}>
                {expandedItem === item.id ? "−" : "+"}
              </span>
            </button>

            {expandedItem === item.id && (
              <div className={styles.content}>
                <p className={styles.answer}>{item.answer}</p>

                {item.hasVideo && item.videoUrl && (
                  <div className={styles.videoContainer}>
                    <h4 className={styles.videoTitle}>Video Explanation:</h4>
                    <video
                      controls
                      className={styles.video}
                      src={item.videoUrl}
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QASection;
